/* eslint-disable react/jsx-key */
/* eslint-disable @next/next/no-img-element */
"use client";
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "./header.css";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import MenuItem from "./MenuItem";
import Link from "next/link";

// ===================== //
// About Array Data
// ===================== //
import {
  aboutMainItem,
  companyData1,
  companyData2,
  projectCosting1,
  dedicatedResources1,
  dedicatedResources2,
  dedicatedResources3,
} from "./HeaderData/aboutData";
import { aboutMainItemMobile } from "./HeaderData/Mobile/aboutData";

// ===================== //
// Blockchain Array Data
// ===================== //
import { blockchainMainItem, EVM1, NFT1, NFT2, NFT3, marketing1, metaverse1, web3_1, web3_2, defi1, defi2, defi3, GenerativeAI1, ico1, sto1, ido1, crypto1, crypto2, blockchain1, blockchain2, } from "./HeaderData/blockchainData";
import { blockchainMainItemMobile } from "./HeaderData/Mobile/blockchainData";

// ===================== //
// Games Array Data
// ===================== //
import { gameMainItem, gameDevelopment1, gameDevelopment2, gameDevelopment3, gameArt1, gameArt2, animation1 } from "./HeaderData/gameData";
import { gamesMainItemMobile } from "./HeaderData/Mobile/gamesData";

// ===================== //
// Industries Array Data
// ===================== //
import { industriesMainItem, education1, education2, bankingFinance1, ecommerce1, ecommerce2, foodRestaurant1, onDemand1, healthcareFitness1, healthcareFitness2 } from "./HeaderData/industriesData";
import { industriesMainItemMobile } from "./HeaderData/Mobile/industriesData";

import DropDownMainItem from "./DropDownMainItem";
import DropDownSubRow3 from "./DropDownSubRow3";
// import MobileView from "./MobileView";
import MobileDropdownMainItm from "./HeaderData/Mobile/MobileDropdownMainItm";
import MobileDropdownSubItm from "./HeaderData/Mobile/MobileDropdownSubItm";
import { usePathname } from "next/navigation";
import AboutUrl from "../../sourceURL/AboutUrl";
import BlockchainUrl from "../../sourceURL/BlockchainUrl";
import GamesUrl from "../../sourceURL/GamesUrl";
import IndustriesUrl from "../../sourceURL/IndustriesUrl";
import CommonButton from "../CommonButton/CommonButton";

const Header = () => {
  const currentPage = usePathname();

  const [ShowTab, setShowTab] = useState(1);
  const [hideShow, sethideShow] = useState(false);
  const [navBgClr, setNavBgClr] = useState(false);
  const [ArrowShow, setArrowShow] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showNavColor, setShowNavColor] = useState(false);
  // Mobile View
  const [subShow, setsubShow] = useState();
  const [isOpen, setIsOpen] = useState(-1);
  const [Service, setService] = useState(-1);

  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleHoverToggle = () => {
    setIsHovered(!isHovered);
  };

  const TabOpen = (x) => {
    setShowTab(x);
  };

  const HideShow = (e, id) => {
    e.preventDefault();
    sethideShow(true, id);
    setNavBgClr(true, id);
    setArrowShow(id);
    setShowTab(1);
  };

  // Function to handle mouse enter on menu item
  const handleMenuItemMouseEnter = (e, id) => {
    setHoveredItem(id);
    HideShow(e, id);
  };

  // Function to handle mouse leave on menu item
  const handleMenuItemMouseLeave = () => {
    setHoveredItem(null);
  };

  function openNav() {
    document.getElementById("mySidenav").style.width = "250px";
  }

  // initial scroll positon on page load
  const [scrollPosition, getScrollPositon] = useState(
    typeof window !== "undefined" && document.documentElement.scrollTop
  );
  // hook and event handlers to keep track of and update scroll
  useEffect(() => {
    window.addEventListener("scroll", () => {
      getScrollPositon(document.documentElement.scrollTop);
    });
  }, []);

  // Nav-Scroll
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = (e) => {
    const header = document.querySelector(".header-section");
    const scrollTop = window.scrollY;
    scrollTop >= 30 ? header.classList.add("is-sticky") : header.classList.remove("is-sticky");
  };

  const navBgStyle = navBgClr ? `bg-[#410ead] text-[#cdcdcd]` : null;

  // path location
  const navTextColor =
    currentPage.split("/")[1] === "games" ||
      currentPage.split("/")[1] === "game-animation" ||
      currentPage.split("/")[1] === "game-art" ||
      currentPage.split("/")[1] === "game-resources" ||
      currentPage.split("/")[1] === "nfts" ||
      currentPage.split("/")[1] === "defi" ||
      currentPage.split("/")[1] === "ai" ||
      currentPage.split("/")[1] === "metaverse" ||
      currentPage.split("/")[1] === "blockchain" ||
      currentPage.split("/")[1] === "marketing" ||
      currentPage.split("/")[1] === "crypto" ||
      currentPage.split("/")[1] === "ico" ||
      currentPage.split("/")[1] === "sto" ||
      currentPage.split("/")[1] === "ido" ||
      currentPage.split("/")[1] === "web3" ||
      (currentPage.split("/")[1] === "blog" &&
        (currentPage.split("/").length === 2 || currentPage.split("/").length > 3)) ||
      currentPage.split("/")[1] === "author" ||
      currentPage.split("/")[1] === "evm" ||
      currentPage.split("/")[1] === "portfolio"
      ? `${scrollPosition < 30 ? "text-white" : `${navBgStyle && scrollPosition < 30 ? ` ${navBgStyle}` : null}`}`
      : null;

  // over path location

  function closeNav(id) {
    setService(true);
    // setshow(!show);
    // setshowData(id);
    // setService(true);
    setsubShow(id);
    document.getElementById("mySidenav").style.width = "0";
  }

  const subDropdown = (id) => {
    // Check if the clicked submenu is already open
    if (subShow === id) {
      // Close it by resetting subShow (so no submenu is open)
      setsubShow(-1);
    } else {
      // Open the clicked submenu (and automatically close any previously open submenu)
      setsubShow(id);
    }

    // Ensure that Service is updated accordingly. Toggle only when subShow changes.
    if (Service !== id) {
      setService(id);
    } else {
      setService(-1); // Close if the same service is clicked again
    }
  };

  const openAccorrdion = (id) => {
    setIsOpen(isOpen === id ? -1 : id);
  };

  return (
    <>
      {
        <header className={`fixed top-0 left-0 right-0 z-[99999] header-section`}>
          {/* <nav id="top-menu-nav"> */}
          {/* ===============DESKTOP MENU=============== */}
          <div className={` ${showNavColor && navBgStyle}  ${navTextColor}`}>
            <div className={`container mx-auto MainMenu`}>
              {/* --------------------LOGO-------------------- */}
              <Link href="/" className="flex items-center">
                {navTextColor ? (
                  <img
                    src={`${scrollPosition < 30 ? "/Mainlogo.webp" : showNavColor ? "/Mainlogo.webp" : "/MainLogo-dark.webp"
                      } `}
                    alt="Tanthetaa-logo"
                    className="xl:w-auto w-auto lg:w-20 cursor-pointer"
                  />
                ) : (
                  <img
                    src={showNavColor ? "/Mainlogo.webp" : "/MainLogo-dark.webp"}
                    alt="Tanthetaa-logo"
                    className="xl:w-auto w-auto lg:w-20 cursor-pointer"
                  />
                )}
              </Link>
              <div className="Menu">
                {/* --------------------Services-blockchain -------------------- */}
                <span
                  className="dropsub"
                  onMouseEnter={() => {
                    // navBgStyle && setShowNavColor(true);
                    setShowNavColor(true);
                    handleHoverToggle();
                  }}
                  onMouseLeave={() => {
                    setShowNavColor(false);
                    handleHoverToggle();
                  }}
                >
                  <MenuItem
                    id={5}
                    navTextColor={navTextColor}
                    title={"Services"}
                    pageUrl={<BlockchainUrl />}
                    // address="/"
                    hideShow={hideShow}
                    HideShow={HideShow}
                    ArrowShow={ArrowShow}
                    Icon1={BiChevronUp}
                    Icon2={BiChevronDown}
                    onMouseEnter={handleMenuItemMouseEnter}
                    onMouseLeave={handleMenuItemMouseLeave}
                    hoveredItem={hoveredItem}
                  />
                  {hideShow && (
                    <ul className="dropdownMenu lg:top-[45px] xl:top-[61px] 2xl:top-[60px]">
                      <div className="grid grid-cols-12">
                        <div className="col-span-2 BgTab overflow-y-scroll lg:h-[87vh]">
                          <div className="pt-2">
                            {blockchainMainItem?.map((item, ind) => (
                              <React.Fragment key={ind}>
                                <DropDownMainItem item={item} ShowTab={ShowTab} TabOpen={TabOpen} />
                              </React.Fragment>
                            ))}
                          </div>
                        </div>

                        {/* NFT */}
                        {ShowTab === 1 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                            <div className="py-4 subMenusList pl-12">
                              {NFT1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {NFT2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {NFT3?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}

                        {/* EVM */}
                        {ShowTab === 2 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[81vh]">
                              <div className="py-4 subMenusList pl-12">
                                {EVM1?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img
                                      src={item?.image}
                                      alt="Company"
                                      className="w-10 px-2"
                                    //className="px-2 w-10"
                                    />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {/* blockchain */}
                        {ShowTab === 3 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                            <div className="py-4 subMenusList pl-12">
                              {blockchain1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {blockchain2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}

                        {/* Metaverse */}
                        {ShowTab === 4 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                              <div className="py-4 subMenusList pl-12">
                                {metaverse1?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img
                                      src={item?.image}
                                      alt="Company"
                                      className="w-10 px-2"
                                    />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {/* Web 3 */}
                        {ShowTab === 5 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                              <div className="py-4 subMenusList pl-12">
                                {web3_1?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img src={item?.image} alt="Company" className="w-10 px-2" />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                              <div className="py-4 subMenusList pl-12 GradientBorder">
                                {web3_2?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img src={item?.image} alt="Company" className="w-10 px-2" />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {/* Crypto */}
                        {ShowTab === 6 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                            <div className="py-4 subMenusList pl-12">
                              {crypto1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {crypto2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}

                        {/* DeFi */}
                        {ShowTab === 7 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[81vh]">
                              <div className="py-4 subMenusList pl-12">
                                {defi1?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img src={item?.image} alt="Company" className="w-10 px-2" />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                              <div className="py-4 subMenusList pl-12 GradientBorder">
                                {defi2?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img src={item?.image} alt="Company" className="w-10 px-2" />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                              <div className="py-4 subMenusList pl-12 GradientBorder">
                                {defi3?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img src={item?.image} alt="Company" className="w-10 px-2" />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {/* Generative AI */}
                        {ShowTab === 8 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[81vh]">
                              <div className="py-4 subMenusList pl-12">
                                {GenerativeAI1?.map((item, ind) => (
                                  <div key={item?.id} className="flex justify-start items-center my-8">
                                    <img
                                      src={item?.image}
                                      alt="Company"
                                      className="w-10 px-2"
                                    />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {/* ICO/STO/IDO */}
                        {ShowTab === 9 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                            <div className="py-4 subMenusList pl-12">
                              {ico1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {sto1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {ido1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}

                        {/* Marketing */}
                        {ShowTab === 10 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[82vh]">
                              <div className="py-4 subMenusList pl-12">
                                {marketing1?.map((item, ind) => (
                                  <div key={item?.id || ind} className="flex justify-start items-center my-8">
                                    <img
                                      src={item?.image}
                                      alt="Company"
                                      className="w-10 px-2"
                                    //className="px-2 w-10"
                                    />
                                    <a
                                      href={item?.href}
                                      className="px-3 subMenuTitle !font-manrope"
                                      onClick={() => {
                                        sethideShow(false);
                                      }}
                                    >
                                      {item?.title}
                                    </a>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </ul>
                  )}
                </span>
                {/* --------------------Services-blockchain end-------------------- */}

                {/* --------------------Games-------------------- */}
                <span
                  className="dropsub"
                  onMouseEnter={() => {
                    setShowNavColor(true);
                    handleHoverToggle();
                  }}
                  onMouseLeave={() => {
                    setShowNavColor(false);
                    handleHoverToggle();
                  }}
                >
                  <MenuItem
                    id={3}
                    navTextColor={navTextColor}
                    title={"Games"}
                    pageUrl={<GamesUrl />}
                    hideShow={hideShow}
                    HideShow={HideShow}
                    ArrowShow={ArrowShow}
                    Icon1={BiChevronUp}
                    Icon2={BiChevronDown}
                    onMouseEnter={handleMenuItemMouseEnter}
                    onMouseLeave={handleMenuItemMouseLeave}
                    hoveredItem={hoveredItem}
                  />
                  {hideShow && (
                    <ul className="dropdownMenu lg:top-[45px] xl:top-[61px] 2xl:top-[60px]">
                      <div className="grid grid-cols-12 ">
                        <div className="col-span-2 BgTab">
                          <div className="pt-2 ">
                            {gameMainItem?.map((item, ind) => (
                              <div key={item.id || ind}>
                                <DropDownMainItem item={item} ShowTab={ShowTab} TabOpen={TabOpen} />
                              </div>
                            ))}
                          </div>
                        </div>
                        {ShowTab === 1 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[87.3vh]">
                            <div className="py-4 subMenusList pl-12">
                              {gameDevelopment1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList GradientBorder">
                              {gameDevelopment2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList GradientBorder">
                              {gameDevelopment3?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 2 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[76vh]">
                            <div className="py-4 subMenusList pl-12">
                              {gameArt1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList GradientBorder">
                              {gameArt2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 3 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll h-[70vh]">
                            <div className="py-4 subMenusList pl-12">
                              {animation1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </ul>
                  )}
                </span>
                {/* --------------------Games end-------------------- */}

                {/* --------------------Industries-------------------- */}
                <span
                  className="dropsub"
                  onMouseEnter={() => {
                    setShowNavColor(true);
                    handleHoverToggle();
                  }}
                  onMouseLeave={() => {
                    setShowNavColor(false);
                    handleHoverToggle();
                  }}
                >
                  <MenuItem
                    id={6}
                    navTextColor={navTextColor}
                    title={"Industries"}
                    pageUrl={<IndustriesUrl />}
                    hideShow={hideShow}
                    HideShow={HideShow}
                    ArrowShow={ArrowShow}
                    Icon1={BiChevronUp}
                    Icon2={BiChevronDown}
                    onMouseEnter={handleMenuItemMouseEnter}
                    onMouseLeave={handleMenuItemMouseLeave}
                    hoveredItem={hoveredItem}
                  />
                  {hideShow && (
                    <ul className="dropdownMenu lg:top-[45px] xl:top-[61px] 2xl:top-[60px]">
                      <div className="grid grid-cols-12">
                        <div className="col-span-2 BgTab overflow-y-scroll h-[75vh]">
                          <div className="pt-2">
                            {industriesMainItem?.map((item, ind) => (
                              <div key={item.id || ind}>
                                <DropDownMainItem item={item} ShowTab={ShowTab} TabOpen={TabOpen} />
                              </div>
                            ))}
                          </div>
                        </div>

                        {ShowTab === 1 ? (
                          <>
                            <div className="col-span-3 py-4 subMenusList pl-12">
                              {onDemand1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 2 ? (
                          <>
                            <div className="col-span-3 py-4 subMenusList pl-12">
                              {foodRestaurant1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 3 ? (
                          <>
                            <div className="col-span-3 py-4 subMenusList pl-12">
                              {bankingFinance1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 4 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[75vh]">
                            <div className="py-4 subMenusList pl-12">
                              {ecommerce1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {ecommerce2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 5 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[75vh]">
                            <div className="py-4 subMenusList pl-12">
                              {healthcareFitness1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {healthcareFitness2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 6 ? (
                          <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[75vh]">
                            <div className="py-4 subMenusList pl-12">
                              {education1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                            <div className="py-4 subMenusList pl-12 GradientBorder">
                              {education2?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </ul>
                  )}
                </span>
                {/* --------------------Industries end-------------------- */}

                {/* --------------------Case Studies-------------------- */}
                <div className="">
                  <span>
                    <a href="/portfolio" className={`menuTitle flex MenuList !font-manrope ${navTextColor}`}>
                      Case Studies
                    </a>
                  </span>
                  {/* view source data */}
                </div>
                {/* --------------------Case Studies end-------------------- */}

                {/* --------------------Blogs-------------------- */}
                <div className="">
                  <span>
                    <a href="/blog" className={`menuTitle flex MenuList !font-manrope ${navTextColor}`}>
                      Blog
                    </a>
                  </span>
                  {/* view source data */}
                </div>
                {/* --------------------Blogs end-------------------- */}

                {/* --------------------About Us-------------------- */}
                <span
                  className="dropsub"
                  onMouseEnter={() => {
                    setShowNavColor(true);
                    handleHoverToggle();
                  }}
                  onMouseLeave={() => {
                    setShowNavColor(false);
                    handleHoverToggle();
                  }}
                >
                  <MenuItem
                    id={1}
                    navTextColor={navTextColor}
                    title={"About Us"}
                    pageUrl={<AboutUrl />}
                    hideShow={hideShow}
                    HideShow={HideShow}
                    ArrowShow={ArrowShow}
                    Icon1={BiChevronUp}
                    Icon2={BiChevronDown}
                    onMouseEnter={handleMenuItemMouseEnter}
                    onMouseLeave={handleMenuItemMouseLeave}
                    hoveredItem={hoveredItem}
                  />
                  {hideShow && (
                    <ul className="dropdownMenu lg:top-[45px] xl:top-[61px] 2xl:top-[60px]">
                      <div className="grid grid-cols-12 ">
                        <div className="col-span-2 BgTab">
                          <div className="pt-2">
                            {aboutMainItem?.map((item, ind) => (
                              <div key={item.id || ind}>
                                <DropDownMainItem item={item} ShowTab={ShowTab} TabOpen={TabOpen} />
                              </div>
                            ))}
                          </div>
                        </div>
                        {ShowTab === 1 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[50vh] 2xl:h-[48vh]">
                              <div className="py-4 subMenusList pl-12">
                                {companyData1?.map((item, ind) => (
                                  <div key={item.id || ind}>
                                    <DropDownSubRow3
                                      TabOpen={TabOpen}
                                      item={item}
                                      setShowNavColor={setShowNavColor}
                                      sethideShow={sethideShow}
                                    />
                                  </div>
                                ))}
                              </div>
                              <div className="py-4 subMenusList pl-12 GradientBorder">
                                {companyData2?.map((item, ind) => (
                                  <div key={item.id || ind}>
                                    <DropDownSubRow3
                                      TabOpen={TabOpen}
                                      item={item}
                                      setShowNavColor={setShowNavColor}
                                      sethideShow={sethideShow}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 2 ? (
                          <>
                            <div className="col-span-3 py-4 subMenusList pl-12">
                              {projectCosting1?.map((item, ind) => (
                                <div key={item.id || ind}>
                                  <DropDownSubRow3
                                    TabOpen={TabOpen}
                                    item={item}
                                    setShowNavColor={setShowNavColor}
                                    sethideShow={sethideShow}
                                  />
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {ShowTab === 3 ? (
                          <>
                            <div className="grid col-span-10 grid-cols-3 overflow-y-scroll lg:h-[85vh] 2xl:h-[88vh]">
                              <div className="py-4 subMenusList pl-12">
                                {dedicatedResources1?.map((item, ind) => (
                                  <div key={item.id || ind}>
                                    <DropDownSubRow3
                                      TabOpen={TabOpen}
                                      item={item}
                                      setShowNavColor={setShowNavColor}
                                      sethideShow={sethideShow}
                                    />
                                  </div>
                                ))}
                              </div>
                              <div className="py-4 subMenusList pl-12 GradientBorder">
                                {dedicatedResources2?.map((item, ind) => (
                                  <div key={item.id || ind}>
                                    <DropDownSubRow3
                                      TabOpen={TabOpen}
                                      item={item}
                                      setShowNavColor={setShowNavColor}
                                      sethideShow={sethideShow}
                                    />
                                  </div>
                                ))}
                              </div>
                              <div className="py-4 subMenusList pl-12 GradientBorder">
                                {dedicatedResources3?.map((item, ind) => (
                                  <div key={item.id || ind}>
                                    <DropDownSubRow3
                                      TabOpen={TabOpen}
                                      item={item}
                                      setShowNavColor={setShowNavColor}
                                      sethideShow={sethideShow}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </ul>
                  )}
                </span>
                {/* --------------------About Us end--------------------  */}

                {/* --------------------Get in Touch-------------------- */}
                <div className="pl-0 lg:pl-5 xl:pl-10">
                  <CommonButton href={`/contact`} name={`Get in Touch`} className="common-blue-button-style" />
                </div>
                {/* --------------------Get in Touch end-------------------- */}
              </div>
            </div>
          </div>

          {/*      ***  ---  ***  DESKTOP END  ***  ---   ***      */}

          {/* 💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫 */}
          {/* 💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫 */}
          {/* 💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫 */}
          {/* 💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫 */}
          {/* 💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫💫 */}

          {/* ===================MOBILE MENU================== */}
          <div className="mobileView fixed bg-white w-full">
            <div className="flex justify-between xl:mx-10 lg:mx-10 mx-6 py-3">
              <Link href="/" className="flex  items-center ">
                <img
                  src={"/MainLogo-dark.svg"}
                  alt="Tanthetaa-logo"
                  className="xl:w-auto w-auto lg:w-20 cursor-pointer"
                />
                {/* )} */}
              </Link>
              <div className="flex gap-2">
                <CommonButton href={`/contact`} name={`Get in Touch`} className="common-blue-button-style" />
                <img
                  className="w-8"
                  src={"/assets/MobileBtn.svg"}
                  alt="MobileBtn"
                  onClick={() => {
                    openNav();
                  }}
                />
              </div>
            </div>
            <div id="mySidenav" className="sidenav">
              <div
                className="closebtn"
                onClick={() => {
                  closeNav();
                }}
              >
                &times;
              </div>

              {/* --------------------Services-blockchain-------------------- */}
              <div className="flex items-center pl-2 justify-start">
                <div
                  type="button"
                  className="dropdown-btn px-3 py-2"
                  onClick={() => {
                    openAccorrdion(1);
                  }}
                >
                  Services
                </div>
                <div
                  className={`${isOpen === 1 ? "open" : "close"} accordion-bg`}
                  onClick={() => openAccorrdion(2)}
                  id="open"
                >
                  <div className="d-flex align-items-center justify-content-between ">
                    <img src={"/assets/menuarrow.svg"} alt="menuarrow" className="faq-arrow" />
                  </div>
                </div>
              </div>
              {isOpen === 1 && (
                <div className=" px-3">
                  {blockchainMainItemMobile?.map((e, ind) => (
                    <div key={e.id || ind}>
                      <MobileDropdownMainItm e={e} ind={ind} subDropdown={subDropdown} />

                      {/* NFT */}
                      {Service && subShow === 1 && (
                        <>
                          {e.nfts?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* EVM */}
                      {Service && subShow === 2 && (
                        <>
                          {e.evm?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* Blockchain */}
                      {Service && subShow === 3 && (
                        <>
                          {e.blockchain?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* Metaverse */}
                      {Service && subShow === 4 && (
                        <>
                          {e.metaverse?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* web 3 */}
                      {Service && subShow === 5 && (
                        <>
                          {e.web3?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* Crypto */}
                      {Service && subShow === 6 && (
                        <>
                          {e.crypto?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* DeFi */}
                      {Service && subShow === 7 && (
                        <>
                          {e.defi?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* Generative AI */}
                      {Service && subShow === 8 && (
                        <>
                          {e.GenerativeAI?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* ICO */}
                      {Service && subShow === 9 && (
                        <>
                          {e.icoStoIdo?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}

                      {/* Marketing */}
                      {Service && subShow === 10 && (
                        <>
                          {e.marketing?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {/* -----------------Services-blockchain end----------------- */}

              {/* --------------------Games-------------------- */}
              <div className="flex items-center pl-2 justify-start">
                <div
                  type="button"
                  className="dropdown-btn px-3 py-2"
                  onClick={() => {
                    openAccorrdion(2);
                  }}
                >
                  Games
                </div>

                <div
                  className={`${isOpen === 2 ? "open" : "close"} accordion-bg`}
                  onClick={() => openAccorrdion(3)}
                  id="open"
                >
                  <div className="d-flex align-items-center justify-content-between ">
                    <img src={"/assets/menuarrow.svg"} alt="menuarrow" className="faq-arrow" />
                  </div>
                </div>
              </div>
              {isOpen === 2 && (
                <div className="px-3">
                  {gamesMainItemMobile?.map((e, ind) => (
                    <div key={e.id || ind}>
                      <MobileDropdownMainItm e={e} ind={ind} subDropdown={subDropdown} />
                      {Service && subShow === 1 && (
                        <>
                          {e.gameDevelopment?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 2 && (
                        <>
                          {e.gameArt?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 3 && (
                        <>
                          {e.animation?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {/* --------------------Game end-------------------- */}

              {/* --------------------Industries-------------------- */}
              <div className="flex items-center pl-2 justify-start">
                <div
                  type="button"
                  className="dropdown-btn px-3 py-2"
                  onClick={() => {
                    openAccorrdion(3);
                  }}
                >
                  Industries
                </div>

                <div
                  className={`${isOpen === 3 ? "open" : "close"} accordion-bg`}
                  onClick={() => openAccorrdion(6)}
                  id="open"
                >
                  <div className="d-flex align-items-center justify-content-between ">
                    <img src={"/assets/menuarrow.svg"} alt="menuarrow" className="faq-arrow" />
                  </div>
                </div>
              </div>
              {isOpen === 3 && (
                <div className=" px-3">
                  {industriesMainItemMobile?.map((e, ind) => (
                    <div key={e.id}>
                      <MobileDropdownMainItm e={e} ind={ind} subDropdown={subDropdown} />
                      {Service && subShow === 6 && (
                        <>
                          {e.education?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 3 && (
                        <>
                          {e.bankingFinance?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 4 && (
                        <>
                          {e.ecommerce?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 2 && (
                        <>
                          {e.foodRestaurant?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 1 && (
                        <>
                          {e.onDemand?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 5 && (
                        <>
                          {e.healthcareFitness?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {/* -----------------Industries end----------------- */}

              {/* -----------------Case Studies----------------- */}
              <div className="flex pl-2 justify-start">
                <Link
                  href="/portfolio"
                  className="dropdown-btn px-3 py-2"
                  onClick={() => {
                    closeNav();
                  }}
                >
                  Case Studies
                </Link>
              </div>
              {/* -----------------Case Studies end----------------- */}

              {/* -----------------Blog----------------- */}
              <div className=" flex  pl-2 justify-start">
                <Link
                  href="/blog"
                  className="dropdown-btn px-3 py-2"
                  onClick={() => {
                    closeNav();
                  }}
                >
                  Blogs
                </Link>
              </div>
              {/* -----------------Blog end----------------- */}

              {/* --------------------About Us-------------------- */}
              <div className="flex items-center pl-2 justify-start">
                <div
                  // href="/"
                  type="button"
                  // id="app-btn"
                  className="dropdown-btn px-3 py-2"
                  onClick={() => {
                    openAccorrdion(4);
                  }}
                >
                  About Us
                </div>

                <div
                  className={`${isOpen === 4 ? "open" : "close"} accordion-bg`}
                  onClick={() => openAccorrdion(4)}
                  id="open"
                >
                  <div className="d-flex align-items-center justify-content-between ">
                    <img src={"/assets/menuarrow.svg"} alt="menuarrow" className="faq-arrow" />
                  </div>
                </div>
              </div>
              {isOpen === 4 && (
                <div className="px-3">
                  {aboutMainItemMobile?.map((e, ind) => (
                    <div key={e.id || ind}>
                      <MobileDropdownMainItm e={e} ind={ind} subDropdown={subDropdown} />
                      {Service && subShow === 1 && (
                        <>
                          {e.companyData?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 2 && (
                        <>
                          {e.projectCosting?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                      {Service && subShow === 3 && (
                        <>
                          {e.dedicatedResources?.map((e, ind) => (
                            <div key={e.id || ind}>
                              <MobileDropdownSubItm e={e} ind={ind} closeNav={closeNav} />
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {/* --------------------About Us End-------------------- */}

              {/* -----------------Get in Touch----------------- */}
              <div className="flex pl-2 justify-start mt-5">
                <Link
                  href="/contact"
                  className="common-blue-button-style !text-white"
                  onClick={() => {
                    closeNav();
                  }}
                >
                  Get in Touch
                </Link>
              </div>
              {/* -----------------Get in Touch end----------------- */}
            </div>
          </div>
          {/*        ***  ---  ***  MOBILE END  ***  ---   ***        */}
          <style>
            {`
              {/* body {
                opacity: ${isHovered ? 0.1 : 1};
                transition: opacity 0.3s ease-in-out;
              } */}
              {/* body main:hover .bg-page-blur {
                opacity: ${isHovered ? 0.1 : 1};
                transition: opacity 0.3s ease-in-out;
              }
              .bg-page-blur:hover {
                opacity: 1 !important;
              }
              .header-section {
                opacity: ${isHovered && 1} !important;
                transition: opacity 0.3s ease-in-out;
              } */}


              {/* .bg-page-blur:hover {
                opacity: 1 !important;
              }
              body main dropsub:hover .bg-page-blur {
                opacity: ${isHovered ? 0.1 : 1};
                transition: opacity 0.3s ease-in-out;
              }
              .header-section {
                opacity: ${isHovered && 1} !important;
                transition: opacity 0.3s ease-in-out;
              }  */}
            `}
          </style>
        </header>
      }
    </>
  );
};

export default Header;


